import React from 'react';
import LogoMark from './LogoMark';

/**
 * LogoFull - ClearEqual brand mark + wordmark lockup.
 *
 * Combines the LogoMark icon with the "ClearEqual" wordmark in a
 * horizontal layout. Use this anywhere the full brand identity needs
 * to be visible: navigation headers, login panels, footers, document headers.
 *
 * Props:
 *   variant: 'navy' (default, for white/light backgrounds) or 'white' (for navy/dark backgrounds)
 *   size: 'sm' (24px icon, text-base), 'md' (32px icon, text-xl), or 'lg' (44px icon, text-2xl). Default 'md'.
 *   tagline: optional tagline string shown below the wordmark in muted color
 *   className: optional wrapper classes
 */
const LogoFull = ({
  variant = 'navy',
  size = 'md',
  tagline = null,
  className = '',
  ...props
}) => {
  const isWhite = variant === 'white';
  const markColor = isWhite ? '#FFFFFF' : '#0F172A';
  const equalsColor = '#F4A43A';
  const wordColor = isWhite ? 'text-white' : 'text-foreground';
  const taglineColor = isWhite ? 'text-white/70' : 'text-muted-foreground';

  const sizeMap = {
    sm: { icon: 24, text: 'text-base', tagline: 'text-xs' },
    md: { icon: 32, text: 'text-xl', tagline: 'text-xs' },
    lg: { icon: 44, text: 'text-2xl', tagline: 'text-sm' },
  };
  const s = sizeMap[size] || sizeMap.md;

  return (
    <div className={'flex items-center gap-2.5 ' + className} {...props}>
      <LogoMark size={s.icon} color={markColor} equalsColor={equalsColor} />
      <div className="flex flex-col leading-tight">
        <span className={'font-bold tracking-tight ' + s.text + ' ' + wordColor}>ClearEqual</span>
        {tagline && (
          <span className={'hidden md:inline ' + s.tagline + ' ' + taglineColor + ' mt-0.5'}>{tagline}</span>
        )}
      </div>
    </div>
  );
};

export default LogoFull;
